module.exports = __webpack_public_path__ + "static/img/meeting-inform.6cae1b93.jpg";